import { useDocumentTitle } from "@/shared/hooks/useDocumentTitle";
export default function AdminBilling() {
	useDocumentTitle("Admin Billing");
	return (
		<div className="p-4">
			<h1 className="text-lg mb-6">Billing</h1>
			<div className="space-y-4">
				<div className="h-40 rounded-lg bg-muted animate-pulse" />
				<div className="h-40 rounded-lg bg-muted animate-pulse" />
			</div>
		</div>
	);
}
